import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

interface LoggedInUser {
  accessToken: string
  refreshToken: string | null
  id: string
  userId: number
  shortReferralLink: string
  referral_code: string
  fullName: string
  email: string
  mobile: string
  photo_uploaded: boolean
  flagUrl: string
  created_at: string
  national_code: string
  document: Document
  status: 'VERIFIED' | 'REJECTED' | 'PENDING' | string
  isUserOld: number
  credit: number
}

export function getUserAction(): Promise<ApiResponse<LoggedInUser>> {
  return api.get<ApiResponse<LoggedInUser>>('/user')
}
